import { Card, Row, Col, Button, Form } from 'react-bootstrap';
import Select, { components } from 'react-select';
import SpinnerButton from '../../../components/SpinnerButton/SpinnerButton';
import { useTranslation } from 'react-i18next';
import { OpportunityStageEnum, RoleEnum } from '../../../api';
import DriveItEasyControlButton from '../../TiAssisto/DriveItEasyControlButton';
import TiassistoElement from '../../TiAssisto/TiassistoElement';
import '../Opportunities.scss';
import i18next from 'i18next';
import { useAuth } from '../../../hooks/useAuth';

const OpportunityHeader = ({
	availableStates,
	currentState,
	setCurrentState,
	opportunityResponse,
	updating,
	changeStateClicked,
	setshowDuplicateModal,
	setHighlighted,
	handleEnableDisableDie,
	isLoadingSaveTiassisto,
	values,
	errors,
	dirty,
	highlighted,
	driveItEasyStatus,
}) => {
	const { t } = useTranslation();
	const { userRole } = useAuth();
	const isSegnalatore = userRole === RoleEnum.SEGNALATORE;

	return (
		<>
			<span className="d-flex sm-notification mt-3">
				{opportunityResponse.isConvertedFromLead__c
					? `* ${i18next.t('opportunity_converted_by_lead')}`
					: ''}
			</span>
			<Card className="mb-4 sticky-header">
				<Card.Body>
					<Row className="d-flex align-items-center justify-content-between">
						{/* Select Status */}
						<Col md={7} className="d-flex align-items-center">
							<div className="me-4">{t('state')}</div>
							<Select
								menuPosition="fixed"
								options={availableStates}
								value={currentState}
								styles={{
									control: (provided) => ({
										...provided,
										width: '300px',
									}),
								}}
								onChange={(opt) => setCurrentState(opt)}
								isDisabled={[
									RoleEnum.SALES,
									RoleEnum.SALES_DEALER,
									RoleEnum.SALES_INTERNAL,
									RoleEnum.SEGNALATORE,
								].includes(userRole)}
								components={{
									Control: ({ children, ...props }) => (
										<components.Control {...props}>
											<div
												style={{ width: '3px', height: '25px' }}
												className={
													'm-1 bg-' + (currentState?.cssClass || 'secondary')
												}
											></div>
											{children}
										</components.Control>
									),
									Option: (props) => (
										<div className="d-flex align-items-center">
											<div
												style={{ width: '3px', height: '25px' }}
												className={
													'm-1 bg-' + (props.data.cssClass || 'secondary')
												}
											></div>
											<components.Option {...props} />
										</div>
									),
								}}
							/>

							{![
								RoleEnum.SALES,
								RoleEnum.SALES_DEALER,
								RoleEnum.SALES_INTERNAL,
								RoleEnum.SEGNALATORE,
							].includes(userRole) && (
								<div style={{ width: 'auto', height: 'auto' }}>
									<Button
										className="w-100 ms-4"
										disabled={
											!currentState ||
											!opportunityResponse ||
											currentState.value === opportunityResponse.StageName ||
											updating
										}
										onClick={changeStateClicked}
									>
										{t('change_state')}
									</Button>
								</div>
							)}
						</Col>

						<Col className="d-flex gap-2 justify-content-end ">
							{/* Drive It Easy button -- visible only if opportunity is closed won*/}
							<TiassistoElement>
								{opportunityResponse?.StageName ===
									OpportunityStageEnum.closed_won && (
									<DriveItEasyControlButton
										driveItEasyStatus={driveItEasyStatus}
										isLoading={isLoadingSaveTiassisto}
										dirty={dirty}
										updating={updating}
										values={values}
										onClick={handleEnableDisableDie}
									/>
								)}
							</TiassistoElement>

							{/* Update button*/}
							<Button
								type="submit"
								disabled={updating || Object.keys(errors).length || !dirty}
							>
								<SpinnerButton label={t('update')} busy={updating} />
							</Button>

							{/* Duplicate Button */}
							{opportunityResponse.Modello__c &&
								!opportunityResponse.ID_Vehicle_HMP__c && !isSegnalatore && (
									<div className="border-start px-2">
										<Button onClick={() => setshowDuplicateModal(true)}>
											{t('duplicate')}
										</Button>
									</div>
								)}

							{![
								RoleEnum.SALES,
								RoleEnum.SALES_DEALER,
								RoleEnum.SALES_INTERNAL,
								RoleEnum.SEGNALATORE,
							].includes(userRole) && (
								<div className="border-start px-2 d-flex align-items-center">
									<span className="me-2">{t('highlighted')}</span>
									<Form.Check
										id="driveItEasyAnchor"
										name="driveItEasy"
										type="switch"
										onChange={() => setHighlighted(!highlighted)}
										checked={highlighted}
										className="hor-form-check-switch mt-2"
										disabled={updating}
									/>
								</div>
							)}
						</Col>
					</Row>
					<Row></Row>
				</Card.Body>
			</Card>
		</>
	);
};

export default OpportunityHeader;
